import { API } from "./baseService";
import APP_CONST from "../../core/shared/constants";

export const doFetchAuditTrailDetail = (category) => {
  const contextPath = `${APP_CONST.API.ARCHIEVE_FILE}${APP_CONST.API.DETAILS}`;
  return API.get(`${contextPath}?category=${category}`);
};

export const doCompleteAuditTrail = (data) => {
  const contextPath = APP_CONST.API.ARCHIEVE_FILE;
  return API.post(contextPath, data);
};

export const doFetchStatusAuditTrail = (data) => {
  const contextPath = `${APP_CONST.API.ARCHIEVE_FILE}${APP_CONST.API.STATUS}`;
  return API.get(`${contextPath}?id=${data}`);
};

export const doCancelAuditTrail = (data) => {
  const contextPath = `${APP_CONST.API.ARCHIEVE_FILE}${APP_CONST.API.CANCEL}`;
  return API.put(contextPath, data);
};

export const doDownloadAuditTrail = (data) => {
  const contextPath = `${APP_CONST.API.TEMPLATE}${APP_CONST.API.ARCHIEVE_FILE}${APP_CONST.API.DOWNLOAD}`;
  return API.post(contextPath, data, { type: "baseTemplateUrl" });
};

export const doFetchSAStoken = (data) => {
  const contextPath = APP_CONST.API.DOCUMENT_SAS_GENERATION;
  return API.get(contextPath);
};

export const doGetTimeFormat = () => {
  const contextPath = APP_CONST.API.STUDY_INFO_ADMIN;
  return API.get(contextPath, { type: "baseTemplateUrl" });
};

export const getEtmfLockStatus = () => {
  const contextPath = APP_CONST.API.ETM_LOCK_STATUS;
  return API.get(contextPath);
};

export const setetmflock = (data) => {
  const contextPath = APP_CONST.API.ETMFLOCK_LOCK;
  return API.put(contextPath, data, { type: "baseTemplateUrl" });
};
export const setetmfunlock = (data) => {
  const contextPath = APP_CONST.API.ETMFLOCK_UNLOCK;
  return API.put(contextPath, data, { type: "baseTemplateUrl" });
};

export const getEnablingMilestoneStatus = () => {
  const contextPath = APP_CONST.API.STUDY_SETTING;
  return API.get(contextPath);
};

export const doEnablingMilestoneStatus = (data) => {
  const contextPath = APP_CONST.API.STUDY_SETTING;
  return API.put(contextPath, data);
};

export const doMaintenanceOnOff = (data) => {
  const contextPath = `${APP_CONST.API.TEMPLATE_MAINTAINCE}/${data}`;
  return API.put(contextPath, {});
};

export const getMaintenanceStatus = () => {
  const contextPath = `${APP_CONST.API.TEMPLATE_MAINTAINCE}${APP_CONST.API.STATUS}`;
  return API.get(contextPath);
};

export const doTMFStructureChanges = () => {
  const contextPath = `${APP_CONST.API.TEMPLATE_MAINTAINCE}${APP_CONST.API.CHANGES}`;
  return API.get(contextPath);
};

export const doRevertStructureChange = (data) => {
  const contextPath = APP_CONST.API.TMF_STRUCTURE_REVERT;
  return API.put(contextPath, data);
};

export const doApplyStructureChange = (data) => {
  const contextPath = `${APP_CONST.API.TEMPLATE_MAINTAINCE}${APP_CONST.API.APPLYCHANGES}`;
  return API.put(contextPath, data);
};

export const getTmfStructureDetails = () => {
  const contextPath = APP_CONST.API.GETTMFSTRUCTUREDETAILS;
  return API.get(contextPath);
};

export const saveTmfStructureDetails = (payload) => {
  const contextPath = APP_CONST.API.STRUCTURE_EDIT;
  return API.post(contextPath, payload);
};

export const getMileStoneList = (payload) => {
  const contextPath = APP_CONST.API.MILESTONES;
  return API.get(contextPath, payload);
};

export const doFetchMileStoneList = () => {
  const contextPath = APP_CONST.API.MILESTONE_LIST;
  return API.get(contextPath);
};

export const getMilestoneToggleView = (payload) => {
  const contextPath = `${APP_CONST.API.ARTIFACT}/${payload}`;
  return API.get(contextPath, payload);
};

export const getCountryList = () => {
  const contextPath = APP_CONST.API.COUNTRY_LIST;
  return API.get(contextPath);
};

export const getSiteList = () => {
  const contextPath = APP_CONST.API.CLINIC_SITES;
  return API.get(contextPath, { type: "WITHOUT_VERSION" });
};

export const getMilestoneDropDownList = () => {
  const contextPath = APP_CONST.API.MILESTONE_FILTER;
  return API.get(contextPath);
};

export const getMilestoneGroupdata = () => {
  const contextPath = APP_CONST.API.MILESTONE_GROUPS;
  return API.get(contextPath);
};

export const getZoneAndSectiondata = () => {
  const contextPath = APP_CONST.API.DOCUMENT_DOCUMENTMASTER;
  return API.get(contextPath);
};

export const getSharedDocument = (data) => {
  const contextPath = APP_CONST.API.documentsharing_TMF + data;
  return API.get(contextPath);
};

export const doFetchStudyInfo = () => {
  const contextPath = APP_CONST.API.STUDY_INFO;
  return API.get(contextPath, { type: APP_CONST.API.BASE_TEMPLATE_URL });
};

export const getDropZoneDocuments = (category) => {
  const contextPath = APP_CONST.API.DROPZONE_DOCUMENTS;
  return API.get(`${contextPath}/${category}`);
};

export const getDropZoneSettings = () => {
  const contextPath = APP_CONST.API.DROPZONE_FILE_COUNT;
  return API.get(contextPath);
};

export const doDropZoneFileScreening = (payload) => {
  const contextPath = APP_CONST.API.DROPZONE_SCREENING;
  return API.post(contextPath, payload);
};

export const doDropZoneFileScreeningCancel = (data) => {
  const contextPath = APP_CONST.API.DROPZONE_SCREENING_CANCEL;
  return API.put(contextPath, data);
};

export const getDropZoneFileScreening = (payload) => {
  const contextPath = APP_CONST.API.DROPZONE_SCREENING;;
  return API.get(`${contextPath}/${payload}`);
};
export const doSaveTMFDropZone = (payload) => {
  const contextPath = APP_CONST.API.DROPZONE_SAVE;
  return API.post(contextPath, payload);
};

export const deleteDropZoneDocument = (payload) => {
  const contextPath = APP_CONST.API.DROPZONE_SAVE;
  return API.delete(`${contextPath}/${payload}`);
};

export const doFileScreeningStatus = (data) => {
  const contextPath = APP_CONST.API.FILE_SCREENING;
  return API.get(`${contextPath}/${data}`);
};

export const doFileScreeningCancel = (data) => {
  const contextPath = APP_CONST.API.FILE_SCREENING_CANCEL;
  return API.put(contextPath, data);
};

export const doFetchOrgAndViedocTemplates = (orgGuid) => {
  const contextPath = APP_CONST.API.TEMPLATE;
  return API.get(`${contextPath}?orgId=${orgGuid}`, { type: "baseTemplateUrl" });
};

export const doFetchStudyTemplates = () => {
  const contextPath = APP_CONST.API.TEMPLATE_STUDY;
  return API.get(contextPath, { type: "document" });
};

export const doExportOrgAndViedocTemplates = (data) => {
  const contextPath = APP_CONST.API.TEMPLATE_EXPORT;
  return API.post(contextPath, data, { responseType: "arraybuffer", type: "EXPORT" });
};

export const doExportStudyTemplate = (data) => {
  const contextPath = APP_CONST.API.STUDY_EXPORT;
  return API.post(contextPath, data, { responseType: "arraybuffer", type: "WITHOUT_VERSION" });
};

export const doExportTmfTemplate = (data) => {
  const contextPath = APP_CONST.API.STRUCTURE_EXPORT;
  return API.post(contextPath, data, { responseType: "arraybuffer", type: "WITHOUT_VERSION" });
};

export const doDeleteOrgAndViedocTemplate = (templateId) => {
  const contextPath = APP_CONST.API.TEMPLATE_DELETE
  return API.delete(
    `${contextPath}?templateId=${templateId}`, { type: "baseTemplateUrl" }
  );
};

export const doDeleteStudyTemplate = (templateId) => {
  const contextPath = APP_CONST.API.STUDY_DELETE;
  return API.delete(
    `${contextPath}?templateId=${templateId}`);
};

export const doRenameOrgTemplate = (data) => {
  const contextPath = APP_CONST.API.TEMPLATE_RENAME;
  return API.put(contextPath, data, { type: "baseTemplateUrl" });
};

export const doRenameStudyTemplate = (data) => {
  const contextPath = APP_CONST.API.STUDY_RENAME;
  return API.put(contextPath, data);
};

export const doRenameSelectedTemplate = (data) => {
  const contextPath = APP_CONST.API.SELECTED_RENAME;
  return API.put(contextPath, data);
};

export const doSelectTemplate = (data) => {
  const contextPath = APP_CONST.API.TEMPLATE_SELECT;
  return API.post(contextPath, data, { type: "baseTemplateUrl" });
};

export const doSelectStudyTemplate = (data) => {
  const contextDocPath = APP_CONST.API.STUDY_SELECT;
  return API.post(contextDocPath, data);
};

export const doInstantiateTemplate = (data) => {
  const contextDocPath = APP_CONST.API.TEMPLATE_INSTANTIATE;
  return API.put(contextDocPath, data);
};

export const doFetchZoneSectionArtifact = (data) => {
  const { from, id } = data;
  return API.get(`/${from}/${id}`);
};

export const doFetchDatingConventionList = () => {
  const contextPath = APP_CONST.API.DATING_CONVENTION;
  return API.get(contextPath);
};

export const doAddNewArtifact = (data) => {
  const contextPath = APP_CONST.API.ADD_EDIT_ARTIFACT;
  return API.post(contextPath, data);
};

export const editZone = (data) => {
  const contextPath = APP_CONST.API.ZONE_EDIT;
  return API.post(contextPath, data);
};

export const editSection = (data) => {
  const contextPath = APP_CONST.API.SECTION_EDIT;
  return API.post(contextPath, data);
};

export const deleteStruture = (data) => {
  const contextPath = APP_CONST.API.STRUCTURE_DELETE;
  return API.put(contextPath, data);
};

export const fetchClientDetails = (data) => {
  const contextPath = APP_CONST.API.CLIENT_DETAILS;
  return API.get(`${contextPath}?auth=${data}`, { type: "EXPORT" });
}

export const fetchRefreshToken = () => {
  const contextPath = APP_CONST.API.REFRESH_TOKEN;
  return API.get(contextPath, { type: 'baseTemplateUrl' });
}

export const cloneDocNewVersion = (data) => {
  const contextPath = APP_CONST.API.DOCUMENT_CLONE_SAVE;
  return API.post(contextPath, data);
};

export const getDocumentTemplateNames = (data) => {
  const contextPath = APP_CONST.API.DOCUMENT_TEMPLATE_VARIABLE
  return API.get(contextPath, data);
};

export const etmfSwitchTracking = (data) => {
  const contextPath = APP_CONST.API.ETMF_SWITCH_TRACKING
  return API.post(contextPath, data, { type: 'baseTemplateUrl' });
}